export default __webpack_public_path__ + "static/qrcode-18af9dec9ca478a37c2d24c84d9b0230.png";